import SignUp from 'components/organisms/SignUp';

function SignUpPage() {
  return <SignUp />;
}

export default SignUpPage;
